/**
 * The prefix to use in the protocol
 */
export const PROTOCOL_PREFIX = 'libp2p'

/**
 * The name to use in the protocol
 */
export const PROTOCOL_NAME = 'autonat'

/**
 * The version to use in the protocol
 */
export const PROTOCOL_VERSION = '1.0.0'
export const TIMEOUT = 30000
export const MAX_INBOUND_STREAMS = 2
export const MAX_OUTBOUND_STREAMS = 20
export const DEFAULT_CONNECTION_THRESHOLD = 80
export const MAX_MESSAGE_SIZE = 8192
